import { defineCommands, type CommandsOf, applyEntityDataChanges } from '../../commands/defineCommands';
import type { CanvasStoreContext } from '../../types';
import type { TaskData } from '../../entityTypes';

export const taskCommands = defineCommands({
  'task.updateData': (ctx: CanvasStoreContext, event: {
    entityId: string; dataChanges: Partial<TaskData>;
  }): CanvasStoreContext => applyEntityDataChanges(ctx, event.entityId, event.dataChanges),
});

export type TaskCommand = CommandsOf<typeof taskCommands>;
